import React from 'react';
import { Box, Typography } from '@mui/material';
import { voiceLineDemoHelp, voiceLineModeIntro } from '../utils/voiceLineModeCopy';

/**
 * TASK-922 — Demo is per caller. This panel does not change the line for everyone.
 */
const VoiceLineModePanel = () => (
  <Box
    id="voice-line-mode"
    sx={{
      mt: 1,
      mb: 2,
      p: 2,
      border: 1,
      borderColor: 'divider',
      borderRadius: 1,
    }}
  >
    <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
      How this phone answers
    </Typography>
    <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
      {voiceLineModeIntro}
    </Typography>
    <Typography variant="body2">{voiceLineDemoHelp}</Typography>
  </Box>
);

export default VoiceLineModePanel;
